import React from "react";
import { withAuthorization } from "../Session";

const Home = () => {
  return (
    <div>
      <h1>Placeholder: Home Page.</h1>
      <h4>
        This is the home page for admin user. All the branding needs to be done
        here!
      </h4>
    </div>
  );
};

const condition = authUser => !!authUser;

export default withAuthorization(condition)(Home);
